const RATE_UNITS = {
  hitting: "per plate appearance",
  pitching: "per nine innings",
  nba: "per 36 minutes",
  passing: "per pass attempt",
  rushing: "per rush attempt",
  receiving: "per reception",
};

function rateUnit(league, role) {
  return RATE_UNITS[role] || RATE_UNITS[league] || RATE_UNITS.hitting;
}

export function similarSeasonsGuideCopy({ league, role, season } = {}) {
  const when = season ? ` in ${season}` : "";
  return {
    what: `Other players' seasons with a similar stat profile${when} — not the same player, and not who was better.`,
    chips:
      "The pills are the 2–3 stats this match is most alike on. Hover or focus one for the full name.",
    compare: `Compare numbers is this season vs that neighbor's season on those same stats. Rates are ${rateUnit(
      league,
      role
    )}, not scores out of 10.`,
    rates:
      "Small rates use three decimals (.068 vs .125) so HR/PA and BB/PA don't both look like 0.1.",
    rank: "Closest, Strong, and Similar mean a closer stat profile — not a more famous player.",
  };
}
